import { LoadableFactory } from '®shared/data';

import {
  BookstoreAvailabilityActionTypes,
  BookstoreAvailabilityActions,
} from './bookstore-availability.actions';
import { BookstoreAvailabilityState } from './bookstore-availability.state';

export function bookstoreAvailabilityReducer(
  state: BookstoreAvailabilityState,
  action: BookstoreAvailabilityActions,
): BookstoreAvailabilityState {
  switch (action.type) {
    case BookstoreAvailabilityActionTypes.BOOKSTORE_AVAILABILITY_REQUESTED: {
      const { resourceId, bookstoreId } = action.payload;
      return {
        ...state,
        [resourceId]: {
          ...state[resourceId],
          [bookstoreId]: LoadableFactory.loading(),
        },
      };
    }
    case BookstoreAvailabilityActionTypes.BOOKSTORE_AVAILABILITY_LOADED: {
      const { resourceId, bookstoreId, bookstoreAvailability } = action.payload;
      return {
        ...state,
        [resourceId]: {
          ...state[resourceId],
          [bookstoreId]: LoadableFactory.loaded(bookstoreAvailability),
        },
      };
    }
    case BookstoreAvailabilityActionTypes.BOOKSTORE_AVAILABILITY_LOADING_FAILED: {
      const { resourceId, bookstoreId, error } = action.payload;
      return {
        ...state,
        [resourceId]: {
          ...state[resourceId],
          [bookstoreId]: LoadableFactory.errored(error),
        },
      };
    }
    default: {
      return state;
    }
  }
}
